export function formatAsCurrency(
  value: number,
  fixedDecimals: number = 0, // 2
  noCommas: boolean = false
): string {
  return noCommas
    ? Number(value).toFixed(fixedDecimals)
    : currencyWithCommas(value.toFixed(fixedDecimals));
}

export function hideBalance(amount: number, replacementString: string): string {
  return formatAsCurrency(amount).replace(/[0-9]/g, replacementString);
}

function currencyWithCommas(x: string): string {
  var parts = x.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return parts.join(".");
}
